import React from "react";

// styles
import { ArtistStyled } from "./styles";

// components
import Avatar from "./Avatar";
import Author from "./Author";
import CreatorCountry from "./CreatorCountry";

const Artist = () => {
    return (
        <ArtistStyled>
            <Avatar />
            <Author />
            <CreatorCountry />
        </ArtistStyled>
    );
};

export default Artist;
